import React, { lazy, useMemo } from 'react';
import SuspenseWrapper from '@/components/SuspenseWrapper.tsx';
import MainLayout from '@/layouts/MainLayout';
import ErrorBoundary from '@/components/ErrorBoundary';
import { SessionInitializer } from '@/components/SessionInitializer';
import { getUtmTagsFromUrl } from '@/utils/utm';
import { useRouter } from '@tanstack/react-router';

const LazyCopyPasteTracker = lazy(() => import('@/components/CopyPasteTracker'));

const GetStartedLayout = ({ children }: { children: React.ReactNode }) => {
  const utmTags = useMemo(() => JSON.stringify(getUtmTagsFromUrl()), []);
  const router = useRouter();
  const pathname = router.state.location?.pathname || '';

  return (
    <MainLayout>
      <SessionInitializer utmTags={utmTags} />
      <SuspenseWrapper fallbackClassName="h-0 w-0 opacity-0">
        <LazyCopyPasteTracker />
      </SuspenseWrapper>
      <ErrorBoundary>
        <div key={pathname} className="animate-fade-in w-full">
          {children}
        </div>
      </ErrorBoundary>
    </MainLayout>
  );
};

export default GetStartedLayout;
